(function () {
  'use strict';

  function initToggle() {
    var toggle = document.querySelector('[data-view-toggle]');
    var grid = document.querySelector('.ferrier-collection__grid');
    if (!toggle || !grid) return;

    var buttons = Array.from(toggle.querySelectorAll('.ferrier-view-toggle__btn'));
    var indicator = toggle.querySelector('.ferrier-view-toggle__indicator');

    function setView(view, persist) {
      // Grid attribute güncelle
      grid.setAttribute('data-current-view', view);

      // Button active state
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.view === view);
      });

      // Indicator pozisyonu
      moveIndicator();

      // localStorage'da sakla (kullanıcı tercihi sayfa değişince hatırlansın)
      if (persist !== false) {
        try {
          localStorage.setItem('ferrier-view-mode', view);
        } catch (e) {}
      }
    }

    function moveIndicator() {
      if (!indicator) return;
      var activeBtn = toggle.querySelector('.ferrier-view-toggle__btn.is-active');
      if (!activeBtn) return;

      // Buton pozisyonu + genişliği toggle parent'a göre
      var toggleRect = toggle.getBoundingClientRect();
      var btnRect = activeBtn.getBoundingClientRect();

      indicator.style.left = (btnRect.left - toggleRect.left) + 'px';
      indicator.style.width = btnRect.width + 'px';
    }

    // Click handlers
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.dataset.view, true);
      });
    });

    // Resize handler — indicator pozisyonunu yenile
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(moveIndicator, 100);
    });

    // İlk yükleme — saved tercihi al
    var savedView = 'studio';
    try {
      var stored = localStorage.getItem('ferrier-view-mode');
      if (stored === 'mannequin' || stored === 'studio') {
        savedView = stored;
      }
    } catch (e) {}

    // Async olarak çağır ki layout settle olsun (font yüklenmesi vb.)
    requestAnimationFrame(function () {
      setView(savedView, false);
    });

    // Bir de gecikmeli olarak (font swap'tan sonra) yeniden hizala
    setTimeout(moveIndicator, 200);
    setTimeout(moveIndicator, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggle);
  } else {
    initToggle();
  }
})();